export default __webpack_public_path__ + "static/media/radio-selected.488bb9f7.svg";